/**
 * Applies domain-driven branding
 */

import 'gw-portals-branding-js/SetBranding';

export default angular.module('gw-portals-branding-angular', []);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-branding-angular/index.js
// module id = 1342
// module chunks = 0